import {Route} from "react-router-dom"


/**
 *  RouteUtils
 */
export default class RouteUtils{

    /**
     *  Возврашает список <Route> по списку `AppRoute`
     *
     *  @param {AppRoute[]} routes
     *  @returns {JSX.Element[]}
     */
    static createRoutes( routes ){
        const filtered = routes.filter( route => route.path!==null )
        return filtered.map( (route, index) => (
            <Route key={index} path={route.path} element={route.element} />
        ))
    }


    /**
     *  Путь к родительской странице
     *
     * @param {string} path
     * @returns {?string}
     */
    static pathToParent(path){
        path = path.replace(/\/[*?]*$/,'');
        if(path==='') return null
        path = path.replace( /\/[^/]+\/?$/ , '')
        return path!=='' ? path : '/'
    }


    /**
     * Преобразует список AppRoute в список без чилдов
     *
     * @param {AppRoute[]} routes
     * @param {string} basePath
     */
    // static flattenRoutes(routes, basePath=''){
    //     let result = []
    //     routes.forEach( route => {
    //         // Родитель
    //         const fullPath = this.normalizePath(`${basePath}/${route.path}`)
    //         result.push( route.copyWith({ path: fullPath, children: [] }) )
    //         // Есть дети
    //         if (route.children && route.children.length > 0){
    //             result = result.concat(this.flattenRoutes(route.children, fullPath))
    //         }
    //     })
    //     return result
    // }


    /**
     *  Нормализация Пути
     *
     *  Приводит к пути вида: route1/route2
     *  Удаляет всякие *? и т.п.
     *
     *  @param {string} path
     *  @returns {*}
     */
    // static normalizePath(path){
    //     // Удаление двойных '/'
    //     path = path.replace('//', '/')
    //     // Удаление конечной косой черты '/', а также знака '/*?'
    //     path = path.replace(/\/+[*?]*$/, '')
    //     return path
    // }


}















